module.exports = __webpack_public_path__ + "media/assets/faria_products/IDAT-19f6eb76b7d5085c1947c936867c2373e49798a7d969b75c212e057c4575b8a5.png";